import { createAction } from '@reduxjs/toolkit'


export const RESET_STATE = 'RESET_STATE'

export const resetState = createAction(RESET_STATE)